var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJewelleryLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 32,
    viewBox: "0 0 196 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6461 10.7559V2.53796C32.4346 1.03078 30.3743 0.0859497 28.4018 0.136714C25.5056 0.136714 23.1578 2.51433 23.1578 5.44729V10.7559H33.6461Z",
    fill: "#6F6F6E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9717 5.00217C30.9717 5.33761 30.7031 5.60959 30.3716 5.60959C30.0402 5.60959 29.7716 5.33761 29.7716 5.00217C29.7716 4.66651 30.0402 4.39453 30.3716 4.39453C30.7031 4.39453 30.9717 4.66651 30.9717 5.00217Z",
    fill: "#C6C6C6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6446 6.64758H37.7006L33.6446 2.54004V6.64758Z",
    fill: "#C6C6C6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6446 6.64844V10.7558L37.7006 6.64844H33.6446Z",
    fill: "#1D1D1B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6214 31.9993L6.13315 21.3779H8.31372L18.802 31.9993H16.6214Z",
    fill: "#1D1D1B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0491 31.9993L1.56088 21.3779H3.74167L14.2297 31.9993H12.0491Z",
    fill: "#1D1D1B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4882 10.7559H0V0.134766L10.4882 10.7559Z",
    fill: "#1D1D1B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9771 10.7559H10.4889V0.134766L20.9771 10.7559Z",
    fill: "#6F6F6E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9771 21.3772H10.4889V10.7559L20.9771 21.3772Z",
    fill: "#6F6F6E"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1578 21.3772H33.6461V10.7559L23.1578 21.3772Z",
    fill: "#1D1D1B"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.134766H10.4882V10.7559L0 0.134766Z",
    fill: "#C6C6C6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.7559H10.4882V21.3772L0 10.7559Z",
    fill: "#C6C6C6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4889 21.3779H20.9771V31.9993L10.4889 21.3779Z",
    fill: "#1D1D1B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6461 21.3779H23.1578V31.9993L33.6461 21.3779Z",
    fill: "#C6C6C6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4889 10.7559H20.9771V21.3772L10.4889 10.7559Z",
    fill: "#C6C6C6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1578 21.3772V10.7559H33.6461L23.1578 21.3772Z",
    fill: "#C6C6C6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.487 4.49375C192.421 4.49375 191.55 3.73644 191.55 2.50759C191.55 1.26605 192.421 0.533683 193.487 0.533683C194.541 0.533683 195.412 1.26605 195.412 2.50759C195.412 3.73644 194.541 4.49375 193.487 4.49375ZM193.487 0C192.139 0 190.974 0.9433 190.974 2.50759C190.974 4.05941 192.126 5.02743 193.487 5.02743C194.848 5.02743 196 4.05941 196 2.50759C196 0.9433 194.835 0 193.487 0Z",
    fill: "#1D1D1B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.423 2.33976H193.337V1.61068H193.423C193.67 1.61068 193.821 1.71943 193.821 1.96975C193.821 2.15465 193.724 2.33976 193.423 2.33976ZM194.369 2.95987C194.326 2.66601 194.197 2.49184 193.821 2.43757C194.261 2.36142 194.401 2.12204 194.401 1.91548C194.401 1.5888 194.1 1.37108 193.584 1.37108H192.488V1.59974L192.725 1.62162V3.28634L192.488 3.30822V3.52572H193.584V3.30822L193.337 3.28634V2.55726H193.434C193.617 2.55726 193.703 2.66601 193.724 2.85113L193.778 3.2102C193.81 3.49312 193.982 3.56927 194.283 3.56927C194.444 3.56927 194.487 3.55833 194.67 3.52572V3.30822L194.412 3.28634L194.369 2.95987Z",
    fill: "#1D1D1B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.6399 24.7843H55.9508C55.8789 21.7271 55.8789 18.6337 55.8789 15.0307H57.496C61.7726 15.0307 63.7134 16.632 63.7134 19.9803C63.7134 23.1104 61.6289 24.7843 57.6399 24.7843ZM55.9508 4.40338H57.8555C61.1257 4.40338 62.7073 5.64098 62.7073 8.66147C62.7073 11.7917 61.0542 13.2472 57.3525 13.2472H55.8789C55.8789 10.6997 55.8789 7.49717 55.9508 4.40338ZM61.4492 13.9389C65.7617 13.1017 67.2714 10.8815 67.2714 8.33391C67.2714 4.98586 64.6839 2.54763 59.1852 2.54763H48.1883V4.25765L51.2072 4.58521C51.2788 7.679 51.2788 10.8089 51.2788 13.9026V15.3218C51.2788 18.4882 51.2788 21.5816 51.2072 24.6388L48.1883 24.9661V26.6766H58.2148C66.1212 26.6766 68.565 23.1828 68.565 19.9803C68.565 16.923 66.5166 14.594 61.4492 13.9389Z",
    fill: "#1D1D1B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.1905 19.0341V5.45915L77.3344 0.327343L76.7953 0L70.2544 1.63759V3.05681L72.8779 3.42091V19.0341C72.8779 20.9264 72.8421 22.8191 72.8062 24.7114L70.3622 25.1845V26.6768H79.7064V25.1845L77.2624 24.7114C77.2266 22.8191 77.1905 20.9264 77.1905 19.0341Z",
    fill: "#1D1D1B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.621 27.0043L100.766 26.6767V25.1846L98.5742 24.7113V14.4484L98.6818 9.35314L98.2147 8.95293L92.0692 9.78988V11.1365L94.3332 11.646L94.2256 22.0913C92.932 23.3284 91.4582 24.1656 90.1285 24.1656C88.5475 24.1656 87.685 23.2193 87.685 20.49V14.4484L87.8645 9.35314L87.4333 8.95293L81.1443 9.71724V11.1365L83.48 11.646L83.3364 20.6355C83.3005 25.4395 85.241 27.1861 88.2241 27.1861C90.488 27.1861 92.6086 26.0581 94.3332 23.8381L94.621 27.0043Z",
    fill: "#1D1D1B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.374 16.3408H107.451C107.738 12.0098 109.571 10.4818 111.332 10.4818C113.093 10.4818 114.53 12.0464 114.53 14.2665C114.53 15.5765 114.099 16.3408 112.374 16.3408ZM118.627 16.0498C118.627 11.646 115.824 8.73455 111.583 8.73455C107.055 8.73455 102.851 12.2282 102.851 18.0513C102.851 23.7653 106.301 27.186 111.332 27.186C114.674 27.186 117.118 25.6576 118.519 22.9645L117.477 22.0183C116.291 23.3651 114.926 24.3113 112.805 24.3113C109.787 24.3113 107.594 22.2365 107.415 18.0513H118.412C118.555 17.5055 118.627 16.8867 118.627 16.0498Z",
    fill: "#1D1D1B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.523 24.7843H128.834C128.762 21.7271 128.762 18.6337 128.762 15.0307H130.379C134.656 15.0307 136.597 16.632 136.597 19.9803C136.597 23.1104 134.512 24.7843 130.523 24.7843ZM128.834 4.40338H130.739C134.009 4.40338 135.591 5.64098 135.591 8.66147C135.591 11.7917 133.937 13.2472 130.236 13.2472H128.762C128.762 10.6997 128.762 7.49717 128.834 4.40338ZM134.333 13.9389C138.645 13.1017 140.155 10.8815 140.155 8.33391C140.155 4.98586 137.567 2.54763 132.068 2.54763H121.072V4.25765L124.091 4.58521C124.162 7.679 124.162 10.8089 124.162 13.9026V15.3218C124.162 18.4882 124.162 21.5816 124.091 24.6388L121.072 24.9661V26.6766H131.098C139.005 26.6766 141.448 23.1828 141.448 19.9803C141.448 16.923 139.4 14.594 134.333 13.9389Z",
    fill: "#1D1D1B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.505 19.0341V14.2298L150.613 9.09844L150.038 8.73455L143.569 11.0273V12.4104L146.121 12.738C146.192 14.1937 146.228 15.3217 146.228 17.3236V19.0341C146.228 20.5988 146.228 22.9281 146.192 24.7114L143.82 25.1845V26.6768H152.733V25.1845L150.541 24.7479C150.505 22.9281 150.505 20.5988 150.505 19.0341Z",
    fill: "#1D1D1B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.641 8.73455C164.772 8.73455 162.688 10.4087 161.646 13.5383L161.25 9.09844L160.675 8.73455L154.674 11.0275V12.4103L157.189 12.7379C157.261 14.1937 157.297 15.1035 157.297 17.1052V19.034C157.297 20.599 157.297 22.928 157.261 24.7481L154.961 25.1846V26.6767H164.629V25.1846L161.682 24.6023C161.646 22.819 161.646 20.5626 161.646 19.034V16.3774C162.185 14.4484 163.119 12.9197 164.377 11.8646L164.701 12.2283C165.455 13.1018 166.21 13.5383 167.144 13.5383C168.582 13.5383 169.444 12.5195 169.48 10.6997C169.121 9.426 167.935 8.73455 166.641 8.73455Z",
    fill: "#1D1D1B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.598 23.1103C181.663 24.0928 180.693 24.6022 179.435 24.6022C176.883 24.6022 175.051 22.4552 175.051 18.0514C175.051 13.3931 177.063 11.282 179.471 11.282C180.549 11.282 181.484 11.6824 182.598 12.6651V23.1103ZM186.946 5.45915L187.09 0.327343L186.551 0L179.974 1.63759V3.05703L182.777 3.42113V10.9544C181.484 9.426 180.118 8.73455 178.249 8.73455C174.008 8.73455 170.451 12.3741 170.451 18.1242C170.451 23.7289 173.47 27.1861 177.71 27.1861C179.83 27.1861 181.412 26.3494 182.742 24.7479L183.029 27.0772L189.282 26.6767V25.1844L186.946 24.7842V5.45915Z",
    fill: "#1D1D1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJewelleryLogo);
export default __webpack_public_path__ + "static/media/jewellery-logo.623bed9f0f6c78891550e20a181492dd.svg";
export { ForwardRef as ReactComponent };